import React, {useState, useEffect} from 'react'
import { FaWindowClose } from "react-icons/fa";
import { IconContext } from "react-icons";

const useModal = () => {
  //states
  const [isShowing, setShowing] =useState(false);
  const [overlay, setOverlay] = useState(true);
  const toggle =() => {
    setShowing(!isShowing)
  }
  const returnOverlay =() => {
    setOverlay(false)
  }
  return {
    isShowing,
    overlay,
    returnOverlay,
    toggle,
  } 
}
const PhoneWarnModal = () => {
  //states
  //const [modal, setModal] = useState(true);
  const { isShowing, toggle /*overlay,*/ /*returnOverlay*/} = useModal();
  const [cookieConsent, showCookieConsent] = useState(true);
  const [checked, setIsChecked] = useState(0);
  //functions
  const handleOnchange = (e) =>{
    setIsChecked(e.target.checked);
    localStorage.setItem("hide", e.target.checked);
  }
  useEffect(()=>{
    toggle();
    let modalStorage = localStorage.getItem("hide", checked);
    if (modalStorage) {
      console.log("storage", modalStorage);
      showCookieConsent(false);
    }
  }, [])
  // dark:outline-2  dark:outline dark:outline-offset-2 dark:outline-white use for modal dark mode
  return (
    <>
      {cookieConsent === true && (
        <>
          {isShowing ? (
            <div className="display-pos-container">
              <div className="display-grid-justify">
                <div className="bg-container">
                  <div className="pd-box-container">
                    <div className="windows-close-btn-container">
                      <button style={{display: 'flex', cursor: 'pointer', backgroundColor: 'transparent', padding: '0.5rem'}} className="flex pointer-cursor" onClick={toggle}>
                          <IconContext.Provider value={{size: '1.75em', color: 'white'}}>
                            <div>
                              <FaWindowClose />
                            </div>
                          </IconContext.Provider>
                      </button>
                    </div>
                    <section
                      style={{
                        marginBottom: '1.25rem',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      className="mb-5 flex justify-center items-center"
                    >
                      <h1 
                        style={{
                          textAlign: 'center',
                          display: 'inline-block',
                          fontSize: '18px',
                          fontWeight: '600',
                          fontFamily: 'Press Start 2P'
                        }}
                        className="text-center inline-block text-lg font-bold">
                        Welcome!
                      </h1>
                    </section>
                    <div style={{
                      marginBottom: '0.5rem',
                      fontSize: '14px',
                      alignItems: 'center',
                      textAlign: 'center',
                      fontFamily: 'Press Start 2P'
                    }}
                    className='mb-2 text-sm text-center'>
                      <div style={{fontFamily: 'Press Start 2P'}}>
                        {`3D feature is unavailable on mobile screens 
                          switch to desktop to get a better experience.`}
                      </div>
                    </div>   
                    <div
                      style={{
                        display: 'flex',
                        columnGap: '0.5rem',
                        marginTop: '4rem', 
                        marginRight: 'auto',
                      }}
                      className='flex gap-x-2 mt-8 mr-auto'
                    >
                      <input type="checkbox" id="dont-show" onChange={handleOnchange}/>
                      <p style={{textAlign: 'left', fontSize: '12px'}} className="text-left text-xs">{"Don't Show This Message"}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            ) : (null)
          }
        </>
      )}
    </>
  )
}

export default PhoneWarnModal;